// import React from 'react'
// import FindContestSection from '../../../components/sections/find-contest'
// import Head from 'next/head';

// const Subscription = () => {
//   return (
//   //   <div>  <>
//   //   {profileModal && (
//   //     <UpdateProfile
//   //       profileModal={profileModal}
//   //       setProfileModal={setProfileModal}
//   //       profileNotice={profileNotice}
//   //       setProfileNotice={setProfileNotice}
//   //     />
//   //   )}
//   //   {logoutLoading && (
//   //     <div className="h-screen w-screen flex items-center justify-center">
//   //       <PageLoader
//   //         className="h-80 w-full"
//   //         loadingText="Leaving too soon 😦, we hope to see u again "
//   //       />
//   //     </div>
//   //   )}
//   //   <section className="flex relative bg-white">
//   //     <div className="hidden lg:w-3/12 xl:w-1/5 lg:block">
//   //       <SideNav
//   //         mobileSideNav={mobileSideNav}
//   //         setMobileSideNav={setMobileSideNav}
//   //         role={role}
//   //         profileModal={profileModal}
//   //         setProfileModal={setProfileModal}
//   //         profileNotice={profileNotice}
//   //         setProfileNotice={setProfileNotice}
//   //       />
//   //     </div>
//   //     <div
//   //       className={`absolute z-50 lg:hidden transition-all ease-linear duration-300 h-full ${
//   //         mobileSideNav ? "left-0" : "left-[-22rem]"
//   //       }`}
//   //     >
//   //       <SideNav
//   //         mobileSideNav={mobileSideNav}
//   //         setMobileSideNav={setMobileSideNav}
//   //         role={role}
//   //         profileModal={profileModal}
//   //         setProfileModal={setProfileModal}
//   //         profileNotice={profileNotice}
//   //         setProfileNotice={setProfileNotice}
//   //       />
//   //     </div>

//   //     <div className="w-full lg:w-11/12 xl:w-5/5 lg:mx-5 mx-0">
//   //       <div className="w-full lg:hidden">
//   //         <MobileTopNav
//   //           activeDropDown={activeDropDown}
//   //           setDropDown={setDropDown}
//   //           setMobileSideNav={setMobileSideNav}
//   //           fullName={fullName}
//   //           setLogoutLoading={setLogoutLoading}
//   //         />
//   //       </div>

//   //       <div className="px-2 ">

//   //         <Header
//   //           activeRange={activeRange}
//   //           setActiveRange={setActiveRange}
//   //           fullName={fullName}
//   //           role={role}
//   //           activeDropDown={activeDropDown}
//   //           setDropDown={setDropDown}
//   //           setLogoutLoading={setLogoutLoading}

//   //         />
//   //         <Notification
//   //           message={notification?.notification[0]?.Message}
//   //           status={notification?.notification[0]?.status}
//   //           link={notification?.notification[0]?.link}
//   //         />
//   //         {/* <Filter/> */}
//   //         <main className="lg:mx-3 mx-0 bg-white ">{children}</main>
//   //       </div>
//   //     </div>
//   //   </section>
//   // </></div>

//   <>
//       <Head>
//         <title>Find Contests</title>
//         <meta
//           name="description"
//           content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
//         />
//         <link rel="icon" href="/favicon.png" />
//       </Head>
//       <FindContestSection />
//     </>
//   )
// }

// export default Subscription

import React, { useEffect, useState } from "react";
import Affiliate from "../../../components/sections/affiliate";
import Protected from "../../../hoc/protected-route";
import PageLoader from "../../../components/widgets/page-loader";
import Head from "next/head";
import { getDashboardInfo } from "../../../api-client/dashboard";

import { useRouter } from "next/router";
import { useCookies } from "react-cookie";
import { logout } from "../../../utils/local-storage";
import SubscriptionPage from "../../../components/widgets/subscription";

function Subscription() {
  // Get dashboard Information
  const router = useRouter();
  const [cookies, setCookies] = useCookies();
  const [user, setUser] = useState(null);
  const getUserInfo = async () => {
    const authToken = await cookies.authToken;

    try {
      const res = await getDashboardInfo(authToken);

      setUser(res.data.data);
    } catch (error) {
      if (error.response.status === 401) {
        logout();
        router.push("/auth/sign-in");
      }
    }
  };
  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <>
      <Head>
        <title>Subscription Dashboard</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>

     <section>
    <SubscriptionPage/>
     </section>
    </>
  );
}
export default Protected(Subscription);
